<div class="p-4 space-y-4">
  <h2 class="text-xl font-bold">Unsupported Geo Locations</h2>

  <form (ngSubmit)="onSubmit()" class="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
    <div>
      <label class="block text-sm font-medium mb-1">From Date</label>
      <input type="date" [(ngModel)]="fromDate" name="fromDate" class="w-full border p-2 rounded" required>
    </div>
    <div>
      <label class="block text-sm font-medium mb-1">To Date</label>
      <input type="date" [(ngModel)]="toDate" name="toDate" class="w-full border p-2 rounded" required>
    </div>
    <div>
      <button type="submit" class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" [disabled]="loading">
        {{ loading ? 'Loading...' : 'Fetch' }}
      </button>
    </div>
  </form>

  <div #mapContainer class="w-full h-[480px] border rounded"></div>

  <div *ngIf="!loading && !locations.length" class="text-gray-500 text-sm">No unsupported locations found for the
    selected range.</div>
</div>